import gql from 'graphql-tag'
import api from './apiClient'
import { runSubscription } from '../subscriptor/restaurantOrder'

export default {
  readTotal: emisor =>
    api
      .send({
        query: gql`
          query readTotal($emisor: ID!) {
            Order {
              readTotal(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Order.readTotal),

  readTotalByFilter: (emisor, filter) =>
    api
      .send({
        query: gql`
          query readTotalByFilter($emisor: ID!, $filter: Filter) {
            Order {
              readTotalByFilter(emisor: $emisor, filter: $filter)
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Order.readTotalByFilter),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Order {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  createdAt

                  userSession {
                    _id
                    fullname
                  }
                  consecutive
                  # restaurant {
                  #   _id
                  #   name
                  # }
                  zone {
                    _id
                    name
                  }
                  table {
                    #_id
                    name
                    number
                  }
                  # items {
                  #   _id
                  # }
                  status
                  express
                  state

                  facturacion {
                    _idFactura
                    consecutivo
                    estadoDocumento
                    totalComprobante
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Order.readAllByEmisor),

  readItemDeleted: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readItemDeleted($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Order {
              readItemDeleted(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  authBy {
                    _id
                    fullname
                  }
                  userSession {
                    _id
                    fullname
                  }
                  _idOrder
                  consecutive
                  quantity
                  unitPrice
                  name
                  reason
                  check
                  state
                  createdAt
                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Order.readItemDeleted),

  readItemDeletedByOrder: _idOrder =>
    api
      .send({
        query: gql`
          query readItemDeletedByOrder($_idOrder: ID!) {
            Order {
              readItemDeletedByOrder(_idOrder: $_idOrder) {
                _id
                _idItem
                _idOrder
                authBy {
                  _id
                  fullname
                }
                userSession {
                  _id
                  fullname
                }
                consecutive
                quantity
                unitPrice
                name
                reason
                check
                state
                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _idOrder
        }
      })
      .then(result => result.data.data.Order.readItemDeletedByOrder),

  readByTable: (emisor, zone, table, status) =>
    api
      .send({
        query: gql`
          query READ_ORDER($emisor: ID!, $zone: ID!, $table: ID!, $status: [String!]) {
            Order {
              readByTable(emisor: $emisor, zone: $zone, table: $table, status: $status) {
                _id
                emisor {
                  _id
                }
                userSession {
                  _id
                  fullname
                }
                consecutive
                restaurant {
                  _id
                  name
                }
                zone {
                  _id
                  name
                }
                table {
                  _id
                  name
                  number
                }
                items {
                  _id
                  _idItem
                  _idTemplate
                  _idCategoria
                  userSession {
                    _id
                    fullname
                  }
                  nombre
                  check
                  codigoRapido
                  precioUnitario
                  cantidad
                  detalle
                  itemRefId
                  esCompuesto
                  cuentaContablePorCobrar {
                    _id
                  }
                  index
                  prioridad
                  createdAt
                }
                status
                state
              }
            }
          }
        `,
        variables: {
          emisor,
          zone,
          table,
          status
        }
      })
      .then(result => result.data.data.Order.readByTable),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: OrderInput!) {
            Order {
              create(input: $input) {
                _id
                consecutive
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Order.create),

  setStatus: (_id, status, razon) =>
    api
      .send({
        query: gql`
          mutation SET_STATUS($_id: ID!, $status: OrderStatus!, $razon: String) {
            Order {
              setStatus(_id: $_id, status: $status, razon: $razon)
            }
          }
        `,
        variables: {
          _id,
          status,
          razon
        }
      })
      .then(result => result.data.data.Order.setStatus),

  checkItem: (_idOrder, _id, check) =>
    api
      .send({
        query: gql`
          mutation CHECK_ITEM($_idOrder: ID!, $_id: ID!, $check: Boolean!) {
            Order {
              checkItem(_idOrder: $_idOrder, _id: $_id, check: $check)
            }
          }
        `,
        variables: {
          _idOrder,
          _id,
          check
        }
      })
      .then(result => result.data.data.Order.checkItem),

  checkOrderItems: (_idOrder, _idItems, express) =>
    api
      .send({
        query: gql`
          mutation CHECK_ORDERS_ITEM($_idOrder: ID!, $_idItems: [ID!]!, $express: Boolean) {
            Order {
              checkOrderItems(_idOrder: $_idOrder, _idItems: $_idItems, express: $express)
            }
          }
        `,
        variables: {
          _idOrder,
          _idItems,
          express
        }
      })
      .then(result => result.data.data.Order.checkOrderItems),

  readBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!) {
            Order {
              readBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  createdAt

                  userSession {
                    _id
                    fullname
                  }
                  consecutive
                  zone {
                    _id
                    name
                  }
                  table {
                    name
                    number
                  }
                  status
                  state

                  facturacion {
                    _idFactura
                    consecutivo
                    estadoDocumento
                    totalComprobante
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Order.readBySearchString),

  readOrdersByStatus: (emisor, restaurant, status, categorias, limit) =>
    api
      .send({
        query: gql`
          query readOrdersByStatus($emisor: ID!, $restaurant: ID!, $status: [String!], $categorias: [ID], $limit: Int) {
            Order {
              readOrdersByStatus(emisor: $emisor, restaurant: $restaurant, status: $status, categorias: $categorias, limit: $limit) {
                _id
                consecutive
                zone {
                  _id
                  name
                }
                table {
                  #_id
                  name
                  number
                }
                status
                express
                state
                #createdAt
                #updatedAt

                items {
                  _id
                  # _idItem
                  _idCategoria
                  userSession {
                    _id
                    fullname
                  }
                  nombre
                  # precioUnitario
                  check
                  cantidad
                  detalle
                  codigoRapido
                  prioridad
                  merma
                  mermaDate
                  createdAt
                  # esCompuesto
                  # cuentaContablePorCobrar {
                  #   _id
                  # }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          restaurant,
          status,
          categorias,
          limit
        }
      })
      .then(result => result.data.data.Order.readOrdersByStatus),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Order {
              readById(_id: $_id) {
                _id
                createdAt
                updatedAt
                items {
                  _id
                  _idItem
                  _idCategoria
                  userSession {
                    _id
                    fullname
                  }
                  nombre
                  check
                  precioUnitario
                  cantidad
                  detalle
                  codigoRapido
                  esCompuesto
                  cuentaContablePorCobrar {
                    _id
                  }
                  prioridad
                  createdAt
                }
                restaurant {
                  _id
                  name
                }
                userSession {
                  _id
                  fullname
                }
                consecutive
                zone {
                  _id
                  name
                }
                table {
                  #_id
                  name
                  number
                }
                status
                razon
                mermaDate
                state
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Order.readById),

  subscriptionNewOrder: (emisor, fn) =>
    runSubscription(
      {
        query: gql`
          subscription newOrder($emisor: ID!) {
            newOrder(emisor: $emisor) {
              _id
              operationType
              consecutive
              status
              #updatedAt
              #createdAt
              zone {
                _id
                name
              }
              table {
                #_id
                name
                number
              }
              express
              items {
                _id
                _idItem
                _idCategoria
                userSession {
                  _id
                  fullname
                }
                nombre
                check
                cantidad
                detalle
                codigoRapido
                prioridad
                merma
                mermaDate
                #cuentaContablePorCobrar {
                #  _id
                #}
                categoria {
                  _id
                  categoria
                }
                createdAt
              }
            }
          }
        `,
        variables: {
          emisor
        }
      },
      (err, result) => {
        if (!err) fn(result.data.newOrder)
      }
    ),

  setMermaDate: _idOrder =>
    api
      .send({
        query: gql`
          mutation SET_MERMA_DATE($_idOrder: ID!) {
            Order {
              setMermaDate(_idOrder: $_idOrder)
            }
          }
        `,
        variables: {
          _idOrder
        }
      })
      .then(result => result.data.data.Order.setMermaDate)

  // delete: input =>
  //   api
  //     .send({
  //       query: gql`
  //         mutation delete($input: [ID!]!) {
  //           Order {
  //             delete(input: $input) {
  //               _id
  //               state
  //               message
  //             }
  //           }
  //         }
  //       `,
  //       variables: { input }
  //     })
  //     .then(result => result.data.data.Order.delete)
}
